var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.456 6.509a.52.52 0 0 0-.379.283c-.063.127-.064.135-.072 1.177-.008 1.186.001 1.261.169 1.43.189.188-.445.174 7.826.174 8.271 0 7.637.014 7.826-.174.168-.169.177-.244.169-1.43-.008-1.042-.009-1.05-.072-1.177-.076-.156-.206-.248-.401-.285-.178-.034-14.894-.032-15.066.002","fill":"","fillRule":"evenodd"}));
}

Minus.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
